import { render, staticRenderFns } from "./AllAccount.vue?vue&type=template&id=4d273e53&scoped=true"
import script from "./AllAccount.vue?vue&type=script&lang=js"
export * from "./AllAccount.vue?vue&type=script&lang=js"
import style0 from "./AllAccount.vue?vue&type=style&index=0&id=4d273e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d273e53",
  null
  
)

export default component.exports